import { useMemo } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const useMetaFieldsWithAttributes = (schema) => useMemo(
  () => {
    const metaFields = { ...schema.src.meta_fields };
    if (schema.attributes && Object.entries(schema.attributes).length > 0) {
      const attributes = Object.entries(schema.attributes).map((parent) => parent[1].map((i) => (
        Object.entries({
          [i.alias]: {
            ...i, parent: parent[0], name: i.label, key: i.label,
          },
        }))));
      return (Object.fromEntries(Object.entries(metaFields).concat(...attributes[0])));
    }
    return metaFields;
  },
  [schema.attributes, schema.src.meta_fields],
);
